import {
	OPEN_CHAMPIONSHIP_LEADERBOARD_POPUP,
	CLOSE_CHAMPIONSHIP_LEADERBOARD_POPUP,
} from "../actions";

export const initialState = {
	show: false,
	championship: null,
	filterParams: null,
	modalTitle: null,
	emptyScreenInfo: null,
	emptyScreenThreshold: 0,
	contextParams: null,
	showSearchPlayer: false,
	onPlayerSelected: null,
};

export type LeaderboardState = typeof initialState;

export default function (state = initialState, action) {
	switch (action.type) {
		case OPEN_CHAMPIONSHIP_LEADERBOARD_POPUP: {
			return {
				show: true,
				championship: action.championship,
				filterParams: action.filterParams,
				modalTitle: action.modalTitle,
				showSearchPlayer: action.showSearchPlayer,
				onPlayerSelected: action.onPlayerSelected,
				emptyScreenInfo: action.emptyScreenInfo,
				emptyScreenThreshold: action.emptyScreenThreshold || initialState.emptyScreenThreshold,
				contextParams: {
					backAction: action.backAction,
					addAction: action.addAction,
					removeAction: action.removeAction,
				},
			};
		}

		case CLOSE_CHAMPIONSHIP_LEADERBOARD_POPUP: {
			return {
				...initialState,
				contextParams: null,
				show: false,
			};
		}

		case "@@router/LOCATION_CHANGE": {
			return {
				...initialState,
				show: false,
			};
		}

		default:
			return state;
	}
}
